<router-outlet></router-outlet>
<ngx-spinner [name]="_loading.name"></ngx-spinner>
